import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output
} from '@angular/core';

@Component({
	selector: 'choose-plan',
	templateUrl: './choose-plan.component.html',
	styleUrls: ['./choose-plan.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ChoosePlanComponent {
	@Output()
	public onBack = new EventEmitter<void>();
	@Output()
	public onSelfPay = new EventEmitter<void>();
	@Output()
	public onStudentPay = new EventEmitter<void>();

	constructor () {}

	public back () {
		this.onBack.emit();
	}

	public proceedSelfPay () {
		this.onSelfPay.emit();
	}

	public proceedStudentPay () {
		this.onStudentPay.emit();
	}
}
